var codeblock_default = {
  "blockStyleSpacing": "pVhoP",
  "codeBlock": "O4V0h pVhoP",
  "renderedInTable": "VT0Pf"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
